import "antd/dist/antd.min.css";

import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
  MenuItem,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Search from "@material-ui/icons/Search";
import { Table, Tag } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as knowledgeBaseAction } from "../../redux/miniCrm/knowledgeBase";
import { mapActionsToProps } from "../../redux/miniCrm/topic";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  grid: {
    display: "flex",
    alignItems: "center",
  },
});

class Topic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalAction: false,
      modalDelete: false,
      parentId: "",
      priority: 1,
    };
  }
  async componentDidMount() {
    await this.itemInit();
    this.history = globalHistory();
    this.props.getDataTree();
  }

  listCollumns = [
    { id: "title", numeric: true, disablePadding: false, label: "Chủ đề" },
    // { id: "", numeric: true, disablePadding: false, label: "Chủ đề cha" },
    // { id: "description", numeric: true, disablePadding: false, label: "Miêu tả" },
    { id: "tags", numeric: true, disablePadding: false, label: "Tags" },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Ngày tạo",
    },
    {
      id: "priority",
      numeric: true,
      disablePadding: false,
      label: "Độ ưu tiên",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  columns = [
    {
      title: "Chủ đề",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Tags",
      dataIndex: "tags",
      key: "tags",
      render: (tags) => (
        <>
          {tags?.map((tag, index) => {
            if (index < 2) {
              return (
                <Tag
                  color="#e0e0e0"
                  key={tag}
                  style={{ color: "#000000", borderRadius: "20px" }}>
                  {tag}
                </Tag>
              );
            } else if (index === 2) {
              return (
                <Tag
                  color="#e0e0e0"
                  key={tag}
                  style={{ color: "#000000", borderRadius: "20px" }}>
                  ...
                </Tag>
              );
            }
            return null;
          })}
        </>
      ),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdAt",
      key: "createdAt",
    },
    {
      title: "Độ ưu tiên",
      dataIndex: "priority",
      key: "priority",
    },
    {
      title: "Hành động",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <span>
          <Tooltip title="Chỉnh sửa dữ liệu">
            <EditIcon
              className="hover-cursor"
              onClick={() => this.openModalEdit(null, record)}
            />
          </Tooltip>
          <Tooltip title="Xóa dữ liệu">
            <DeleteIcon
              className="hover-cursor"
              onClick={() => this.openModalDelete(null, record)}
            />
          </Tooltip>
        </span>
      ),
    },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "title":
              if (key.startsWith("title")) {
                where["title"] = { like: filters.where.title };
              }
              break;
            case "icon":
            case "klbId":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.countListTopic({ where: where });
    this.props.getListTopic(filters.order, filters.pageSize, filters.page, {
      where,
    });
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalAction: false, modalDelete: false });
  };

  openModalEdit = (text, item) => {
    this.state.item = item;
    this.setState({ modalAction: true });
  };

  openModalDelete = (text, item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        itemCreate: {
          ...this.state.itemCreate,
          [name]: e.target.value,
        },
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({ modalAction: true, item: {}, itemCreate: { priority: 1 } });
  };

  handleAction = () => {
    const { id } = this.state.item;
    let data = [];
    if (!id) {
      const { title, description, tags, parentId, priority } =
        this.state.itemCreate;
      const newItem = tags.split(",");
      newItem.forEach((element) => {
        data.push(element);
      });
      return (
        this.props.addNewTopic(
          title,
          description,
          { tags: data },
          parentId,
          priority
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    } else {
      const { id, title, description, tags, parentId, priority } =
        this.state.item;
      const newItem = tags.toString().split(",");
      newItem.forEach((element) => {
        data.push(element);
      });
      return (
        this.props.editTopic(
          id,
          title,
          description,
          { tags: data },
          parentId,
          priority
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deleteTopic(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  showPickedIcon = (ico) => {
    this.setState({
      icon: ico.name,
    });
  };

  showPickedIconEdit = (ico) => {
    this.setState({
      item: {
        ...this.state.item,
        icon: ico.name,
      },
    });
  };

  onHandleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };

  render() {
    const { classes, listTopic } = this.props;
    const {
      title,
      description,
      tags,
      filters,
      item,
      modalDelete,
      parentId,
      priority,
      itemCreate,
    } = this.state;
    let dataTreeFormat = [];
    let listTopicFormat = [];
    if (listTopic) {
      dataTreeFormat = JSON.parse(JSON.stringify(listTopic)).map((item) => {
        if (item)
          item.createdAt = moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss");
        formatDataTree(item);
        return item;
      });

      function formatDataTree(item) {
        if (item.children !== undefined) {
          if (!item.children.length) {
            delete item.children;
          } else {
            item.children.map((it) => {
              if (it)
                it.createdAt = moment(it.createdAt).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
              return formatDataTree(it);
            });
          }
        }
      }

      listTopic.forEach((topic) => {
        const tempTopic = JSON.parse(JSON.stringify(topic));
        delete tempTopic.children;
        listTopicFormat.push(tempTopic);
        formatListTopic(topic);
      });

      function formatListTopic(topic) {
        if (topic.children !== undefined) {
          if (topic.children.length) {
            topic.children.forEach((item) => {
              const tempItem = JSON.parse(JSON.stringify(item));
              delete tempItem.children;
              listTopicFormat.push(item);
              return formatListTopic(item);
            });
          }
        }
      }
    }

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <Grid container spacing={24}>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Tên chủ đề"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.title}
                        name="title"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Tags"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.tags}
                        name="tags"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>

                    <Grid item md={3}>
                      <Tooltip title="Tìm kiếm" disableFocusListener>
                        <Fab
                          color="primary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}>
                          <Search />
                        </Fab>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <div>
          <div
            style={{
              marginTop: "15px",
            }}>
            <Grid xs={12} container>
              <Grid xs={8} item>
                <h6
                  style={{
                    color: "rgba(0, 0, 0, 0.87)",
                    fontSize: "1.25rem",
                    marginLeft: "10px",
                    marginTop: "10px",
                    fontWeight: 500,
                    lineHeight: 1.6,
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    letterSpacing: "0.0075em",
                  }}>
                  Danh sách chủ đề
                </h6>
              </Grid>
              <Grid
                xs={4}
                item
                style={{ display: "flex", justifyContent: "flex-end" }}>
                <Tooltip title="Thêm mới" disableFocusListener>
                  <Fab
                    color="primary"
                    aria-label="add"
                    className={classes.fab}
                    size="small"
                    onClick={this.handleCreateModel}>
                    <Add className={classes.add} />
                  </Fab>
                </Tooltip>
              </Grid>
            </Grid>
          </div>
          <Table
            columns={this.columns}
            dataSource={dataTreeFormat}
            rowKey="id"
            pagination={false}
            locale={{ emptyText: "Chưa có dữ liệu" }}
            style={{
              marginTop: "20px",
              boxShadow:
                "0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)",
            }}
          />
        </div>
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
        <Dialog
          open={this.state.modalAction}
          title={
            item ? (item.id ? "Chỉnh sửa thông tin" : "Thêm thông tin") : null
          }
          fullwidth={true}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Chủ đề cha"
                    autoFocus={true}
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("parentId")
                          : this.handleChangeText("parentId")
                        : null
                    }
                    value={
                      item
                        ? item.id
                          ? item.parentId
                          : itemCreate.parentId
                        : ""
                    }
                    name="parentId">
                    <MenuItem>Trống</MenuItem>
                    {listTopicFormat ? (
                      listTopicFormat.map((val) => {
                        if (item) {
                          if (item.id) {
                            if (val.id != item.id) {
                              return (
                                <MenuItem key={val.id} value={val.id}>
                                  {val.title}
                                </MenuItem>
                              );
                            }
                          } else {
                            return (
                              <MenuItem key={val.id} value={val.id}>
                                {val.title}
                              </MenuItem>
                            );
                          }
                        }
                      })
                    ) : (
                      <React.Fragment />
                    )}
                  </SelectValidator>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Độ ưu tiên"
                    variant="outlined"
                    defaultValue={1}
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("priority")
                          : this.handleChangeText("priority")
                        : null
                    }
                    value={
                      item ? (item.id ? item.priority : itemCreate.priority) : 1
                    }
                    name="title"
                    validators={["required", "matchRegexp:^[1-9][0-9]?$|^100$"]}
                    errorMessages={[
                      "Không được để trống",
                      "Chỉ được nhập số lớn hơn 1 và nhỏ hơn 100",
                    ]}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên chủ đề"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("title")
                          : this.handleChangeText("title")
                        : null
                    }
                    value={
                      item ? (item.id ? item.title : itemCreate.title) : null
                    }
                    name="title"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tags"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("tags")
                          : this.handleChangeText("tags")
                        : null
                    }
                    value={
                      item ? (item.id ? item.tags : itemCreate.tags) : null
                    }
                    name="tags"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                  {/* <Grid container className={classes.grid}>
                                        <Grid item lg={8}>
                                            <TextValidator
                                                id="outlined-full-width"
                                                margin="normal"
                                                placeholder="Icon"
                                                variant="outlined"
                                                className={classes.input}
                                                // onChange={!!item ? (item.id ? this.handleChangeTextEdit('icon') : this.handleChangeText('icon')) : null}
                                                value={!!item ? (item.id ? item.icon : icon) : ''}
                                                disabled
                                                name="icon"
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start"><Icon>{!!item ? (item.id ? item.icon : icon) : ''}</Icon></InputAdornment>,
                                                }}
                                            // validators={["required"]}
                                            // errorMessages="Không được để trống"
                                            // helperText="Icon theo chuẩn Material UI - https://material.io/tools/icons/?style=baseline"
                                            />
                                        </Grid>
                                        <Grid item lg={1}></Grid>
                                        <Grid item lg={3}>
                                            <MaterialUiIconPicker onPick={!!item ? (item.id ? this.showPickedIconEdit : this.showPickedIcon) : null} label="Chọn Icon" pickLabel="Done" />
                                        </Grid>
                                    </Grid> */}
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Miêu tả"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("description")
                          : this.handleChangeText("description")
                        : null
                    }
                    value={
                      item
                        ? item.id
                          ? item.description
                          : itemCreate.description
                        : null
                    }
                    name="description"
                    multiline
                    rows={5}
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                  <DialogActions>
                    <Button
                      onClick={this.handleClose}
                      color="secondary"
                      className={classes.button}>
                      Hủy
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}>
                      Lưu
                    </Button>
                  </DialogActions>
                </Grid>
              </FormControl>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
      </React.Fragment>
    );
  }
}

Topic.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  coutTopic: state.topic.count,
  listTopic: state.topic.listTopic,
});

const KnowledgeBase = connect(mapStateToProps, knowledgeBaseAction)(Topic);
Topic = connect(null, mapActionsToProps)(KnowledgeBase);

export default withStyles(styles)(Topic);
